/* eslint-disable filename-rules/match */
import { useEffect, useState } from "react";
// eslint-disable-next-line no-restricted-imports
import { toast } from "react-toastify";

import { serverCheckMigrationStatus, serverRunMigrations } from "api/api-server-migrations";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { toastErrorMessage, toastSuccessMessage, toastWarningMessage } from "utils/alerts";

const applyMigrations = async () => {
  const toastId = "migrations-toast";
  toastSuccessMessage(`Applying migrations...`, {
    toastId,
    isLoading: true,
  });
  try {
    const result = await serverRunMigrations();
    toast.dismiss(toastId);
    if (result.success) {
      toastSuccessMessage("Migrations applied successfully!");
      // Re-check migration status after applying
      const newStatus = await serverCheckMigrationStatus();
      if (!newStatus.has_unapplied_migrations) {
        // Dismiss the warning toast since migrations are now applied
        // Note: We can't directly dismiss toasts, but the success message will show
      }
    } else {
      throw new Error(`Failed to apply migrations`);
    }
  } catch (error) {
    console.error("Failed to run migrations:", error);
    toastErrorMessage("Failed to apply migrations. Please run them manually.");
  } finally {
    toast.dismiss(toastId);
    // Usually migrations go much faster than the loading indicator, so we re-dismiss it after a short delay
    // to avoid race conditions.
    setTimeout(() => {
      toast.dismiss(toastId);
    }, 3000);
  }
};

export const useCheckMigrationStatus = () => {
  const [isApplyingMigrations, setIsApplyingMigrations] = useState(false);

  const handleApplyMigrations = async () => {
    setIsApplyingMigrations(true);
    await applyMigrations();
    setIsApplyingMigrations(false);
  };

  // Check for unapplied migrations in development mode
  useEffect(() => {
    if (window._env_.ENV !== "local" || isApplyingMigrations) {
      return;
    }

    const checkMigrations = async () => {
      try {
        const migrationStatus = await serverCheckMigrationStatus();
        if (migrationStatus.has_unapplied_migrations) {
          toastWarningMessage(
            <div className="flex gap-2">
              <div className="max-w-[200px] whitespace-pre-wrap">
                You have {migrationStatus.count} unapplied migrations. Do you want to apply them
                now?
              </div>
              <SquareButton
                kind="secondary"
                size="m"
                onClick={(e) => {
                  e.preventDefault();
                  handleApplyMigrations();
                }}
              >
                Apply
              </SquareButton>
            </div>,
          );
        }
      } catch (error) {
        console.error("Failed to check migration status:", error);
        // const message = isAxiosError(error) ? error.response?.data.error : "Unknown error";
        // toastErrorMessage(`Failed to check migration status: ${message}`);
      }
    };

    checkMigrations();
  }, [isApplyingMigrations]);
};
